import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { userTypeSelector, userListedSelector } from 'selectors'
import { UNAUTHORIZED, CUSTOMER, CONSULTANT, ADMIN } from 'userTypes'

import Unauthorized from './Unauthorized'
import Consultant from './Consultant'
import Customer from './Customer'
import Admin from './Admin'

const Header = ({ userType, listed, ...rest }) => {
  switch (userType) {
    case ADMIN:
      return <Admin {...rest} />
    case CUSTOMER:
      return <Customer {...rest} />
    case CONSULTANT:
      return listed ? <Customer {...rest} /> : <Consultant {...rest} />
    case UNAUTHORIZED:
    default:
      return <Unauthorized {...rest} />
  }
}

const mapStateToProps = state => ({
  userType: userTypeSelector(state),
  listed: userListedSelector(state),
})

export default withRouter(connect(mapStateToProps)(Header))



// WEBPACK FOOTER //
// ./src/components/Header/index.js